module.exports = __webpack_public_path__ + "img/heartbeatfamlogo.3e580995.svg";